import React, { useEffect, useState } from 'react';
import "@/styles/common/common.css";
import "@/styles/admin/Orex.css";
import "@/styles/admin/developer.css";
import "@/styles/stepper/stepper.css";
import StepperHeader from '@/components/stepper/StepperHeader';
import StepperContainer from '@/pages/admin/Stepper/StepperContainer';
import StepperFooter from '@/components/stepper/StepperFooter';
import { connect } from 'react-redux';
import { getSupplierMember } from '@/actions/stepperAction';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/AuthProvider';
import { onboardingRoutePaths } from '@/routes/onboarding.route.config';
import { buildPath } from '@/utils/common';
import roles from '@/constant/roles.config';
import Emitter from '@/utils/Emitter';

const Stepper = (props) => {

  const { id } = useParams();
  const { memberCompanyID, setUser } = useAuth();
  const nav = useNavigate();

  const [activeStep, setActiveStep] = useState(1);
  const [supplierMember, setSupplierMember] = useState([]);
  const [percentage, setPercentage] = useState(0);

  const fetchSupplier = async (initial = true) => {

    if (!memberCompanyID || parseInt(id) !== memberCompanyID) {
      return;
    }

    await props.getSupplier(memberCompanyID)
      .then((response) => {
        console.log("API response:", response); // check actual shape/status
        console.log("**********************", response.data.profile_complete)
        if (response.status === true) {
          setSupplierMember(response.data);
          if(initial) {
            setActiveStep(response.data.current_step);
          }
          
          // let u = localStorage.getItem("user");
          // u = JSON.parse(u);
          // console.log("u >>>", u);
          // u.current_step = response.data.current_step;
          // u.company_status = response.data.step_1.status;
          // u.company_plan_name = response.data.step_3.plan_name;
          // u.company_plan = response.data.step_3.plan_id;
          // console.log("updated user >>>>>>>>>>>>> ", u);
          localStorage.setItem("user", JSON.stringify(response.data.user_details));
          setUser(response.data.user_details);
          setPercentage(parseInt(response.data.profile_complete));
        } else {
          console.log("Status check failed, response.status was:", response.status);
        }
      })
      .catch((err) => {
        console.log("Error =", err); // don't swallow this while debugging
      });
  };

  useEffect(() => {

    if(!memberCompanyID) return;
    if(memberCompanyID !=  null && (id != memberCompanyID)) {
      const path = buildPath(onboardingRoutePaths.STEPPER_FORM, {
        id: memberCompanyID,
      });
      nav(`/${roles.ON_BOARDING.prefix}/${path}`, { replace: true});
    }
  },[id, memberCompanyID, nav]);

  useEffect(() => {

    if (!id || !memberCompanyID) return;
    
    if (parseInt(id) === memberCompanyID) {
      fetchSupplier(true);
    }
  }, [id, memberCompanyID]);

 

  return (
    <>
       <StepperHeader percentage={percentage} />
          <StepperContainer
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            supplierMember={supplierMember}
            fetchSupplier={fetchSupplier}
            percentage={percentage}
          />
       <StepperFooter/>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
   
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSupplier: (member_id) => dispatch(getSupplierMember(member_id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps) (Stepper);
